export function validateLink(link) {
  const urlRegex = /^(?:(?:https?|ftp):\/\/)?(?:www\.)?[a-z0-9-]+(?:\.[a-z0-9-]+)+[^\s]*$/i;
  return urlRegex.test(link) ? '' : 'incorrect url';
}

export function validateDate(dateStr) {
  if (!dateStr) {
    return;
  };

  return !isNaN(Date.parse(dateStr)) ? '' : 'incorrect date';
}

export function validateNumber(number) {
    return !isNaN(parseFloat(number)) && isFinite(number) ? '' : 'incorrect number';
}